import { Reducer } from 'redux';
import {
  ProductState, ProductActionTypes,
  GET_PRODUCT_LIST,
  GET_PRODUCT,
  POST_PRODUCT,
  PUT_PRODUCT,
  DELETE_PRODUCT,
  UPDATE_PRODUCT_FILTERS
} from '../types/product.types';

const initialState: ProductState = {
  products: [],
  selectedProduct: null,
  postSuccess: null,
  lastFetch: null,
  filters: null,
  totalElements: 0,
  totalPages: 0
};

export const productReducer: Reducer<ProductState> = (
  state: ProductState = initialState, action
) => {
  const timeOfAction = new Date().getTime();

  switch ((action as ProductActionTypes).type) {
    case GET_PRODUCT_LIST:
      return {
        ...state,
        products: action.payload.page.content,
        totalElements: action.payload.totalElements,
        totalPages: action.payload.totalPages,
        selectedProduct: null,
        postSuccess: null,
        lastFetch: timeOfAction
      };
    case GET_PRODUCT:
      return {
        ...state,
        postSuccess: null,
        selectedProduct: action.payload.selectedProduct,
        lastFetch: timeOfAction
      };
    case POST_PRODUCT:
      return {
        ...state,
        postSuccess: true,
        selectedProduct: action.payload.newProduct,
        lastFetch: timeOfAction
      };
    case PUT_PRODUCT:
      return {
        ...state,
        selectedProduct: action.payload.selectedProduct,
        postSuccess: true,
        lastFetch: timeOfAction
      };
    case DELETE_PRODUCT:
      return {
        ...state,
        selectedProduct: null,
        lastFetch: timeOfAction
      };
    case UPDATE_PRODUCT_FILTERS:
      return {
        ...state,
        filters: action.payload.filters
      };
    default:

      return state;
  }
};
